import React, { useEffect, useState } from 'react';
import { Spin, message, Tabs, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ProductsTable from '../../components/productsTable/ProductsTable';
import OptionsTable from '../../components/optionsTable/OptionsTable';
import { fetchProducts } from '../../redux/products/actionCreator';
import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';
import { Cards } from '../../components/cards/frame/cards-frame';
import { Main } from '../styled';

const { TabPane } = Tabs;
const { Search } = Input;

const Products = () => {
  const { loading } = useSelector(state => state.products);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [state, setState] = useState({ loadingScreen: false });
  const [activeTab, setActiveTab] = useState('1');
  const [searchName, setSearchName] = useState('');
  const [searchNameOptions, setSearchNameOptions] = useState('');

  useEffect(() => {
    if (activeTab === '1') {
      dispatch(fetchProducts({ page: pageNumber, searchName }));
    }
  }, [pageNumber, dispatch, activeTab, searchName]);

  const handleOnChangePageNumber = number => {
    setPageNumber(number);
  };

  const handleOnDeleteProduct = async idToRemove => {
    setState({
      ...state,
      loading: true,
    });

    DataService.delete(`${API.pos.products}/${idToRemove}`)
      .then(_data => {
        message.success('Producto Eliminado');
        setState({ ...state, loading: false });
        dispatch(fetchProducts({ page: pageNumber, searchName }));
      })
      .catch(_err => {
        setState({ ...state, loading: false });
      });
  };

  const handleSearchProducts = value => {
    setSearchName(value);
    setPageNumber(1);
  };

  const handleSearchOptions = value => {
    setSearchNameOptions(value);
  };

  return (
    <Main>
      <Cards headless>
        <Tabs activeKey={activeTab} onChange={setActiveTab} size="large" tabBarGutter={48}>
          <TabPane tab="Productos" key="1">
            <div style={{ marginBottom: 16 }}>
              <Search
                placeholder="Buscar productos por nombre..."
                allowClear
                size="large"
                onSearch={handleSearchProducts}
                style={{ width: 400 }}
              />
            </div>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
              </div>
            ) : (
              <ProductsTable
                pageNumber={pageNumber}
                onChangePageNumber={handleOnChangePageNumber}
                onDeleteProduct={handleOnDeleteProduct}
              />
            )}
          </TabPane>
          <TabPane tab="Opciones" key="2">
            <div style={{ marginBottom: 16 }}>
              <Search
                placeholder="Buscar opciones por nombre..."
                allowClear
                size="large"
                onSearch={handleSearchOptions}
                style={{ width: 400 }}
              />
            </div>
            <OptionsTable searchName={searchNameOptions} />
          </TabPane>
        </Tabs>
      </Cards>
    </Main>
  );
};

export default Products;
